import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { EntranceDateSubForm } from '../subforms/EntranceDate';
import { SalaryRequestSubForm, Schema as SalaryRequestSchema } from '../subforms/SalaryRequest';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { DocumentsStandardSubForm, Schema as DocumentsStandardSchema } from '../subforms/DocumentsStandard';

export const GundlachKaufmaennischSchema = (settings) => (
    Yup.object()
        .concat(NameAndContactSchema(settings))
        .concat(SalaryRequestSchema)
        .concat(OtherInformationSchema(settings))
        .concat(DocumentsStandardSchema(settings))
);

export const GundlachKaufmaennisch = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={SalaryRequestSubForm} colors={colors} />
            <Field component={OtherInformationSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsStandardSubForm} colors={colors} settings={settings} />
        </>
    );
}